module.exports = __webpack_public_path__ + "img/game01.184b798e.png";